import { useUpdateEffect } from 'ahooks'
import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import {
  FeeMethod,
  FeeMethodTextMap,
  FeeMethodUnitMap
} from '@eastcoal/shared/enums/FeeMethod'

import { EntranceFeeInputProps } from './interface'

const options = [
  {
    label: FeeMethodTextMap[FeeMethod.NONE],
    value: FeeMethod.NONE
  },
  {
    label: FeeMethodTextMap[FeeMethod.SESSION],
    value: FeeMethod.SESSION
  }
]

const Component = ({
  disabled,
  value = {},
  onChange
}: EntranceFeeInputProps) => {
  // 当没有入场费时清空已输入的入场费金额
  useUpdateEffect(() => {
    if (
      value.entranceFeeMethod === FeeMethod.NONE &&
      !isNil(value.entranceFeeValue)
    ) {
      onChange?.({ ...value, entranceFeeValue: 0 })
    }
  }, [value.entranceFeeMethod])

  const handleSelectChange = (entranceFeeMethod: FeeMethod) => {
    onChange?.({
      ...value,
      entranceFeeMethod
    })
  }

  const handleInputChange = (entranceFeeValue: number | string | null) => {
    onChange?.({
      ...value,
      entranceFeeValue: isNil(entranceFeeValue) ? 0 : Number(entranceFeeValue)
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        value={value.entranceFeeMethod}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled || value.entranceFeeMethod === FeeMethod.NONE}
        min={0}
        value={value.entranceFeeValue}
        style={{
          width: '100%'
        }}
        onChange={handleInputChange}
      />
      {!isNil(value.entranceFeeMethod) && (
        <Space.Addon>{FeeMethodUnitMap[value.entranceFeeMethod]}</Space.Addon>
      )}
    </Space.Compact>
  )
}

export const EntranceFeeInput = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
